import * as mobx from 'mobx'
import ObservableViewport from './ObservableViewport'

// See variables.scss $width-min-xx
enum breakPoints {
  small = 767,
  medium = 992,
  xl = 1600,
}

/**
 * Observable screen media queries.
 */
export default class MediaQuery {
  public viewPort = new ObservableViewport()

  /** <= 767 */
  get smScreen() {
    return this.viewPort.size.width <= breakPoints.small
  }

  /** <= 992 */
  get mdMinusScreen() {
    return this.viewPort.size.width <= breakPoints.medium
  }

  /** <= 959 */
  get isMobileMedia() {
    // TODO: refactor all the media queries variables;
    return this.viewPort.size.width <= 959
  }

  /** [767, 992] */
  get mdScreen() {
    return (
      this.viewPort.size.width > breakPoints.small && this.viewPort.size.width <= breakPoints.medium
    )
  }

  /** > 767 */
  get mdPlusScreen() {
    return this.viewPort.size.width > breakPoints.small
  }

  /** > 992 */
  get lgScreen() {
    return this.viewPort.size.width > breakPoints.medium
  }

  /** >= 1600 */
  get xlScreen() {
    return this.viewPort.size.width >= breakPoints.xl
  }

  constructor() {
    mobx.makeAutoObservable(this, undefined, { autoBind: true, deep: false })
  }
}
